// Lightweight client-side JWT payload decoding for UI role gating ONLY.
// This does NOT verify the signature — never trust it for real authorization.
// The backend re-validates the token and re-checks the user's role (fresh from
// the database) on every admin request.

export interface TokenPayload {
  userId: number;
  email: string;
  role?: string;
  language?: string;
  exp?: number;
}

export function decodeToken(token: string): TokenPayload | null {
  try {
    const payload = token.split('.')[1];
    if (!payload) {
      return null;
    }
    // Convert base64url -> base64 before decoding.
    const normalized = payload.replace(/-/g, '+').replace(/_/g, '/');
    return JSON.parse(atob(normalized)) as TokenPayload;
  } catch {
    return null;
  }
}
